/**
 * PATH: packages/email-hub/src/feature/pages/inboxRowClickNav.ts
 * FILE_ID: EMAILHUB-FEATURE-PAGES-INBOXROWCLICKNAV-001
 * PURPOSE: Canonical body of this email pages module. Lifted
 *          from apps/<tenant>/src/features/email/pages/inboxRowClickNav.ts
 *          (see docs/architecture/EMAIL_KANBAN_CUTOVER_ARC.md).
 *          Tenants import this via thin re-export shims; edit
 *          THIS file, not the tenant copies.
 * WHY:     Removes operator-visible drift between tenants —
 *          previously every email feature change had to be
 *          mirrored manually in two tenant trees, and concurrent
 *          agents kept letting one side go stale. One canonical
 *          body, both tenants consume from this package.
 * RELATED:
 *   - apps/<tenant>/src/features/email/pages/inboxRowClickNav.ts: thin re-export
 *     shim that points back here.
 */

import { emailPath } from '../lib/basePath'
import { isComposePath } from './inboxComposeMode'

export interface RowClickNavDecision {
  /** When non-null, the InboxPage row-click handler should call
   *  `navigate(href, { replace: true })` BEFORE updating
   *  `selectedEmailId`. When null, no navigation is needed (the
   *  current path already lets the preview pane render). */
  navigateTo: string | null
}

/**
 * Decide whether the router should move when the operator clicks an
 * inbox row. The only case that requires moving today is when we're
 * sitting on `/email/compose` — the right pane is locked into the
 * compose surface there, and the click would otherwise be a no-op.
 *
 * Pure I→O: no react / no router coupling. Test in isolation.
 */
export function nextNavOnRowClick(currentPath: string | null | undefined): RowClickNavDecision {
  if (isComposePath(currentPath)) return { navigateTo: emailPath('/inbox') }
  return { navigateTo: null }
}
